import Snackbar from '@mui/material/Snackbar';
import Alert from '@mui/material/Alert';
import { useSelector,useDispatch } from 'react-redux';
import { useEffect,useState } from 'react';
import {closeSuccess,closeError } from '../../stores/slices/commonSlice';
export default function SnackBar() {
  const [open, setOpen] = useState(false);
  const [message,setMessage]=useState('');
  const [type,setType]=useState(null);
  const error=useSelector(state=>state.common.error);
  const success=useSelector(state=>state.common.success);
  const dispatch=useDispatch();
  useEffect(() => {
    let intervalId;

    if (error) {
      setType("error");
      setMessage(error);
      setOpen(true);
      intervalId = setTimeout(() => {
        dispatch(closeError());
        setOpen(false);
      }, 5000);
    } else if (success) {
      setType("success");
      setMessage(success);
      setOpen(true);
      intervalId = setTimeout(() => {
        dispatch(closeSuccess());
        setOpen(false);
      }, 5000);
    }

    return () => {
      if (intervalId) {
        clearInterval(intervalId);
      }
    };
  }, [error, success]);

  const handleClose = (event, reason) => {
    setOpen(false);
  };

  return (
    <div>
      <Snackbar open={open} autoHideDuration={5000} onClose={handleClose}
        anchorOrigin={{ vertical: 'top', horizontal: 'right' }}
      >
        <Alert
          onClose={handleClose}
          severity={type}
          variant="filled"
          sx={{ width: '100%' }}
        >
        {message}
        </Alert>
      </Snackbar>
    </div>
  );
}
